<template>
  <div>
    <div>
      <nav-top></nav-top>
    </div>

    <div class="container">
      <!--    顶部菜单栏-->

      <!--     左侧-->
      <div class="leftContent">
        <!--左上角水求图-->
        <div class="sqt">
          <div class="sqlText">在线/离线设备</div>
          <online-rate ref="sqtComponents" :on-line-number-data="onLineNumberData"></online-rate>
        </div>
        <!--          左侧在线-->
        <div class="online">
          <div class="sqlText">设备在线情况</div>
          <on-line ref="onlineComponents"></on-line>
        </div>
        <!-- 全部设备-->
        <div class="allDevice">
          <!--表格组件-->
          <div class="sqlText">全部设备列表</div>
          <table-list :tableLabel="allDevice.tableLabel" :tableData="allDevice.tableData" :loading="false"
                      :table-height="'20vh'"
                      @tableGetMore="searchAllDevice"
                      @childHandle="parentHandleAll"
                      :more-state="allDevice.tableMoreStatus" :fixed="'right'"
          >
            <template v-slot:btnText>
              实时监控
            </template>
          </table-list>
        </div>
      </div>

      <!--    中间-->

      <div class="middleContent">
        <div class="map">
          <!-- <map-chart ref="mapComponents" @mapChange="mapHandle"></map-chart> -->
          <img src="../assets/mapBottomBg.png" alt="" class="mapBottomBg">
          <div class="mapTable">
          <!-- <div class="sqlText mapTableText">{{ currentCityMap }}</div> -->
          <div class="sqlText mapTableText">
            <el-select v-model="currentCityMap" @change="mapHandle">
                  <el-option :value="item.value" :label="item.label" v-for="(item,index) in selectData" :key="index"></el-option>
                </el-select>
          </div>

          
          <table-list
              :tableLabel="map.tableLabel"
              :tableData="map.tableData"
              :loading="false"
              :table-height="'69vh'"
              :slotNum="2"
              :more-state="map.tableMoreStatus"
              @tableGetMore="mapClickDataHandle(true)"
              @childHandle="parentHandleMap">
            <template v-slot:btnText>
              设备明细
            </template>
            <template v-slot:btnText2>
              报警记录
            </template>
          </table-list>

        </div>
        </div>
        
      </div>

      <!--    右边-->
      <div class="rightContent">
        <div class="warningC">
          <div class="sqlText sqlText2">警报统计</div>
          <div>
            <bar-component ref="barComponents"></bar-component>
          </div>
        </div>
        <div class="warningC warningCMiddle" >
          <div class="sqlText sqlText2">故障警报记录</div>
          <div @click="warningClick($event)" v-if='newsList.length > 0'>
            <vue-seamless-scroll :data="newsList" class="seamless-warp" :class-option="optionSingleHeight">
              <ul class="item">
                <li v-for="(item,index) in newsList">
                  <span class="redIcon"><span class="redIcon2"></span></span>
                  <span class="titleWarning" v-text="item.alertText" :data-index="index"></span>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <div v-else style="color: #fff; text-align: center;padding-top: 50px;font-size: 12px;">
            暂无未处理报警记录
          </div>

        </div>
        <div class="warningC">
          <div class="sqlText sqlText2">视频设备</div>
          <table-list :tableLabel="videoDevice.tableLabel" :tableData="videoDevice.tableData" :loading="false"
                      :table-height="'20vh'"
                      @tableGetMore="haveVideoDevice(true)"
                      :more-state="videoDevice.tableMoreStatus"
                      @childHandle="parentHandleVideo" :fixed="'right'">
            <template v-slot:btnText>
              监控
            </template>
          </table-list>
        </div>
      </div>
      <el-dialog :title="titlePop" :visible.sync="dialogTableVisible2" width="80%" class="searchForm"
                 v-show="titlePop === '实时监控'">
        <div class="searchTable" v-show="titlePop === '实时监控'">
          <iframe :src="ssjkIframeUrl" frameborder="0" style="width: 100%;height:50vh;"></iframe>
        </div>
      </el-dialog>
      <!--    在线查询弹窗-->
      <el-dialog :title="titlePop" :visible.sync="dialogTableVisible" :width="widthTable" class="searchForm">
        <el-form :inline="true" :model="allDeviceForm" class="demo-form-inline" size="mini" label-width="90px"
                 v-show="titlePop === '设备明细'">
          <el-table :data="deviceTableDataInfo" :row-class-name="tableRowClassName">
            <el-table-column property="areaName" label="区域"></el-table-column>
            <el-table-column property="equipName" label="设备名称"></el-table-column>
            <el-table-column property="equipUuid" label="设备ID"></el-table-column>
            <el-table-column property="bindIotId" label="标签点表名"></el-table-column>
            <el-table-column property="equipModel" label="设备规格"></el-table-column>
            <el-table-column property="factoryNo" label="出厂编号"></el-table-column>
            <el-table-column property="manufacture" label="生产厂家"></el-table-column>
          </el-table>
        </el-form>
        <div class="searchTable" v-show="titlePop === '报警记录'">
          <el-table :data="warningTableData" :row-class-name="tableRowClassName">
            <el-table-column property="date" label="报警时间" width=""></el-table-column>
            <el-table-column property="address" label="区域"></el-table-column>
            <el-table-column property="name" label="设备名称"></el-table-column>
            <el-table-column property="gg" label="设备规格"></el-table-column>
            <el-table-column property="info" label="报警信息"></el-table-column>
            <el-table-column property="result" label="处理结果"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <!--    报警记录查看弹窗-->
      <el-dialog title="报警信息查看" :visible.sync="dialogTableVisibleWarning" width="45%">
        <el-table :data="warningTableData" :row-class-name="tableRowClassName">
          <el-table-column property="date" label="报警时间" width=""></el-table-column>
          <el-table-column property="address" label="区域"></el-table-column>
          <el-table-column property="name" label="设备名称"></el-table-column>
          <el-table-column property="gg" label="设备规格"></el-table-column>
          <el-table-column property="info" label="报警信息"></el-table-column>
          <el-table-column property="result" label="处理结果"></el-table-column>
        </el-table>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import mapChart from '../components/map.vue'
import onlineRate from '../components/onlineRate.vue'
import onLine from '../components/online.vue'
import navTop from '../components/nav.vue'
import popComponent from '../components/popComponent.vue'
import barComponent from '../components/bar.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'
import {
  haveVideoDevice,
  mapClickData,
  allDevice,
  searchDeviceInfo,
  updateDeviceInfo,
  deviceWarningInfo,
  getWarningInfo,
  getWarningNumber,
  mapHoverData
} from '../api/home'
import {getToken} from '../util/auth'


export default {
  name: "index",
  components: {
    navTop,
    mapChart,
    onlineRate,
    onLine,
    popComponent,
    barComponent,
    vueSeamlessScroll
  },
  data() {
    return {
      widthTable: '45%',
      deviceTableDataInfo: [],
      ssjkIframeUrl: 'http://120.27.14.57:9993/iotEquipMgr/monitorStatus/view_remote.html?equipUuid=1322092853060567040&bindIotId=libs_elem_analysis02',
      //全部设备表格数据
      allDevice: {
        tableLabel: [
          {prop: 'geoCity', label: '区域', width: '60px'},
          {prop: 'equipName', label: '设备名称', width: '100px'},
          {prop: 'equipSpec', label: '规格型号'},
          {prop: 'factoryNo', label: '出厂编号'},
          {prop: 'manufacture', label: '归属单位'},
          {prop: 'v5', label: '操作'}
        ],
        searchLabel: [
          {prop: 'geoCity', label: '区域', width: '60px'},
          {prop: 'equipName', label: '设备名称',},
          {prop: 'equipSpec', label: '规格型号'},
          {prop: 'factoryNo', label: '出厂编号'},
          {prop: 'manufacture', label: '归属单位'},
        ],
        tableData: [],
        searchData: [],
        searchPage: 1,//当前页
        tablePage: 1,//当前页
        pageSize: 2,//一次调取几条
        tableTotal: 0,
        searchTotal: 0,
        searchMoreStatus: true,
        tableMoreStatus: true
      },
      //在线查询弹窗form
      allDeviceForm: {
        address: '',
        equipName: "",
        geoProvince: "",
        geoCity: "",
        geoCounty: "",
        factoryNo: "",
        manufacture: "",
        equipSpec: ""
      },
      onLineNumberData: {
        offline: [],
        online: [],
      },
      //地图
      map: {
        tableLabel: [
          {prop: 'areaName', label: '区域', width: '100px'},
          {prop: 'orgName', label: '归属单位',},
          {prop: 'onlineCount', label: '设备在线', width: '80px'},
          {prop: 'offlineCount', label: '设备离线', width: '80px'},
          {prop: 'v5', label: '操作', width: '180px'}
        ],
        //地图下方表格的数据
        tableData: [],
        pageNumber: 1,//当前页码
        total: 0,//总的条数
        tableMoreStatus: true,//加载更多的方法
      },
      //视频监控
      videoDevice: {
        tableLabel: [
          {prop: 'geoPcc', label: '区域'},
          {prop: 'equipName', label: '设备名称'},
          {prop: 'equipSpec', label: '规格型号'},
          {prop: 'factoryNo', label: '出厂编号'},
          {prop: 'orgName', label: '归属单位'},
          {prop: '', label: '操作'},
        ],
        tableData: [],
        tableMoreStatus: true,
        pageNumber: 1,
      },
      popShow: false,
      newsList: [
        {
          title: "北京市海淀区XXX设备XXX报警",
          date: "2020-08-08"
        },
        {
          title: "北京市海淀区XXX设备XXX报警",
          date: "2020-08-08"
        }
      ],
      pageSize: 10,//每页调取10条
      titlePop: '',//弹出框的大标题
      dialogTableVisible: false,
      dialogTableVisible2: false,
      dialogTableVisibleWarning: false,
      warningTableData: [
        {
          date: '2020-11-11 10:59:50',
          address: '北京市海淀区',
          name: 'xxxx设备',
          info: '北京市海淀区xxxx设备xxxx报警',
          result: "已处理",
          gg: 'xxx规格'
        },
      ],//
      currentCityMap: '北京市', //存储当前地图点击的城市
      warningTimer:null,//报警信息的定时器
      selectData:[
      ],
    }
  },
  created(){
    this.selectData = []
    mapHoverData({
        jsessionId: sessionStorage.token,
        geoPcc: '',
      }).then(res => {
        if (res.data.code === 0) {
          res.data.data.forEach(i => {
            this.selectData.push({
              value:i.provinceName,
              label:i.provinceName
            })
          })
        }
      }).catch(err => {

      })
  },
  mounted() {
    var resizeTimer = null
    var _this = this
    window.onresize = function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        _this.$refs.sqtComponents.resizeChart();//重绘
        _this.$refs.onlineComponents.resizeChart();
        // _this.$refs.mapComponents.resizeChart();
        _this.$refs.barComponents.resizeChart();
      }, 500);
    }
    this.haveVideoDevice(false)//查询带摄像头的设备
    this.mapClickDataHandle(this.currentCityMap)//地图下方表格的数据
    this.searchAllDevice()
    this.getWarningInfo()
    this.warningTimer = setInterval(() => {
      this.getWarningInfo()
      
    mapHoverData({
        jsessionId: sessionStorage.token,
        geoPcc: '',
      }).then(res => {
        if (res.data.code === 0) {
          this.selectData = []
          res.data.data.forEach(i => {
            this.selectData.push({
              value:i.provinceName,
              label:i.provinceName
            })
          })
        }
      }).catch(err => {

      })
    },2000)
  },
  destroyed() {
    clearInterval(this.warningTimer)
  },
  methods: {
    /**
     * 全部设备查询
     * */
    searchAllDevice(searchStatus, searchGetMore) {
      //在线查询弹窗form
      let obj = {
        "jsessionId": sessionStorage.token,
        "pageNum": this.allDevice.tablePage,
        "pageSize": this.pageSize
      }
      if (searchStatus) { //查询
        if (searchGetMore) {
          this.allDevice.searchPage = 1
          this.allDevice.searchData = []
        }
        obj = {
          "jsessionId": sessionStorage.token,
          "equipName": this.allDeviceForm.equipName,
          "geoProvince": this.allDeviceForm.geoProvince,
          "geoCity": this.allDeviceForm.geoCity,
          "geoCounty": this.allDeviceForm.geoCounty,
          "factoryNo": this.allDeviceForm.factoryNo,
          "manufacture": this.allDeviceForm.manufacture,
          "equipSpec": this.allDeviceForm.equipSpec,
          "pageNum": this.allDevice.searchPage,
          "pageSize": this.pageSize
        }
      }
      allDevice({
        ...obj
      }).then(res => {
        if (res.data.code === 0) {
          if (searchStatus) {
            res.data.data.records.length < this.pageSize ? this.allDevice.searchMoreStatus = false : ''
            this.allDevice.searchData.push(...res.data.data.records);
            this.allDevice.searchTotal = res.data.data.total
            this.allDevice.searchPage++
          } else {
            res.data.data.records.length < this.pageSize ? this.allDevice.tableMoreStatus = false : ''
            this.allDevice.tableData.push(...res.data.data.records);
            this.allDevice.tableTotal = res.data.data.total
            this.allDevice.tablePage++
          }
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    /**
     * 地图下方表格的数据
     * */
    mapClickDataHandle(getMore) {
      if (!getMore) {
        this.map.pageNumber = 1;
        this.map.tableData = []
        this.map.tableMoreStatus = true
      }
      mapClickData({
        jsessionId: sessionStorage.token,
        geoProvince: this.currentCityMap,
        pageNum: this.map.pageNumber,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.data.code === 0) {
          res.data.data.length < this.pageSize ? this.map.tableMoreStatus = false : ''
          if (getMore) {//如果是加载更多
            this.map.pageNumber++
            this.map.tableData.push(...res.data.data)
          } else {
            this.map.tableData = res.data.data
          }
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    /**
     * haveVideoDevice 查询带摄像头的设备
     * **/
    haveVideoDevice(getMore) {
      if (!getMore) {
        this.videoDevice.pageNumber = 1;
        this.videoDevice.tableData = []
        this.videoDevice.tableMoreStatus = true
      }
      haveVideoDevice({
        jsessionId: getToken('token'),
        pageNum: this.videoDevice.pageNumber,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.data.code === 0) {
          res.data.data.records.length < this.pageSize ? this.videoDevice.tableMoreStatus = false : ''
          if (getMore) {//如果是加载更多
            this.videoDevice.pageNumber++
            this.videoDevice.tableData.push(...res.data.data.records)
          } else {
            this.videoDevice.tableData = res.data.data.records
          }
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    /**
     * 报警记录的查看
     * @param item
     */
    warningClick(item) {
      console.log(item)
      this.dialogTableVisibleWarning = true
    },
    /**
     * 地图下方表格数据
     * @param data
     */
    mapHandle(data) {
      this.currentCityMap = data
      this.mapClickDataHandle(false)
    },
    //全部设备列表操作  在线查询
    parentHandleAll(data) {
      this.ssjkIframeUrl = `http://120.27.14.57:9993/iotEquipMgr/monitorStatus/view_remote.html?equipUuid=${data.equipUuid}&bindIotId=${data.bindIotId}`
      // this.titlePop = "实时监控"
      // this.dialogTableVisible2 = true
      window.open(this.ssjkIframeUrl);
    },
    //地图列表操作  报警记录 设备明细
    parentHandleMap(data, type) {
      this.titlePop = type
      this.dialogTableVisible = true
      if (type === "报警记录") {//查询报警记录
        let obj = {
          jsessionId: sessionStorage.token,
          orgUuid: data.orgUuid,
          areaName: data.areaName
        }
      } else if (type === "设备明细") { //查询设备明细
        searchDeviceInfo({
          jsessionId: sessionStorage.token,
          areaName: data.areaName,
          orgUuid: data.orgUuid
        }).then(res => {
          this.deviceTableDataInfo = res.data.data
        })
      }

    },
    //视频设备 操作点击 监控
    parentHandleVideo(item) {
      this.$router.push({path: '/hkv', query: {}})
    },
    closeHandleParent() {
      this.popShow = false
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'rowOne';
      }
      return '';
    },
    //滚动报警信息-
    getWarningInfo() {
      getWarningInfo({
        jsessionId: sessionStorage.token
      }).then(res => {
        if (res.data.code === 0) {
          if(JSON.stringify(this.newsList) != JSON.stringify(res.data.data.records)){
            res.data.data.records.forEach(item => {
              item.alertText = item.geoPcc + '-' + item.alertText + item.createdTime
            })
            this.newsList = res.data.data.records
          }
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    //报警记录 查询设备报警信息
    deviceWarningInfo() {
      deviceWarningInfo({
        jsessionId:sessionStorage.token,
      }).then(res => {
        if (res.data.code === 0) {

        }
      })
    },
  },
  computed: {
    optionSingleHeight() {
      return {
        // singleHeight: 26,
        // waitTime: 2500
        // step:1
      }
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  background-color: #0D1456;
  box-shadow: 0px 0px 3px 3px #0A82D7;
}

.allDevice, .sqt, .online {
  height: 28vh;
  margin-bottom: 2vh;
  background-image: url("../assets/onlinebg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 8% 5%;
  position: relative;
}

.allDevice {
  margin: 0;
}

.sqlText {
  position: absolute;
  top: 0;
  right: 30%;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  letter-spacing: 2px;
}

.leftContent, .rightContent {
  width: 25vw;
  overflow: hidden;
}

.middleContent {
  width: 47.6vw;
  overflow: hidden;
}

.mapBottomBg {
  width: 65%;
  margin: 0 auto;
  margin-top: -10vh;
}

.container {
  background-image: url("../assets/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 93vh;
  padding: 1vh 1.2vw 1.2vh 1.2vw;
  box-sizing: border-box;
}

.map {
  background-image: url("../assets/mapTop.png");
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  height: 88vh;
  margin-bottom: 2vh;
  padding-top: 9vh;
  text-align: center;
}

.mapTable {
  height: 81vh;
  background-image: url("../assets/mapTableBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 5% 3%;
  width: 93%;
  margin: 0 auto;
  /*margin-bottom: 2vh;*/
  position: relative;
  padding-top:8%;
}

.mapTableText {
  position: absolute;
  top: 1%;
  right: 41.5%;
}


.fl {
  float: left;
}

.leftContent, .middleContent, .rightContent {
  display: inline-block;
}

.rightContent .warningC {
  width: 100%;
  height: 28vh;
  margin-bottom: 2vh;
  background-image: url("../assets/rightContentBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

}


.rightContent .warningC:last-child {
  margin: 0;
  padding: 8% 5%;
}

/deep/ .el-table td, /deep/ .el-table th.is-leaf {
  background: #030E43;
  /*060C30*/
  color: #fff;
  border: 0;
}

/deep/ .el-table tr:hover td, /deep/ .el-table th.is-leaf {
  background: #fff;
  /*060C30*/
  color: #333;
  border: 0;
}

.sqlText2 {
  left: 33%;
}

/deep/ .el-table th, /deep/ .el-table tr {
  background-color: transparent;
}

/deep/ .el-table::before {
  height: 0;
}
/deep/ .sqlText .el-input__inner{
  background: transparent;
    height: 28px;
    color:#fff;
    width: 135px;
    border-color: #409EFF;
}
/deep/ .sqlText  .el-select .el-input .el-select__caret{
  line-height: 28px;
}

.warningCMiddle {
  padding-top: 4vh;
}

.titleWarning {
  cursor: pointer;
}

.warningCMiddle .seamless-warp {

}

.seamless-warp li {
  line-height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF322C;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.redIcon {
  display: flex;
  width: 12px;
  height: 12px;
  border: 1px solid #FF322C;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}

.redIcon2 {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #FF322C;
  border-radius: 50%;
}

.seamless-warp {
  height: 20vh;
  overflow: hidden;
  /*padding-left: 2vw;*/
}

/deep/ .searchTable .el-table__body-wrapper {
  max-height: 40vh;
  overflow-y: auto;
}

/deep/ .el-table .rowOne td {
  background: #060C30;
}

/deep/ .el-table .rowTwo td {
  background: #060B4B;
}

/deep/ .el-table, .el-table__expanded-cell {
  background-color: transparent;
}

/deep/ .el-table {
  border: 1px solid #13358C;
}

/deep/ .el-table th.is-leaf, /deep/ .el-table td.gutter, /deep/ .el-table th.gutter {
  background: #18227C;
  padding: 3px;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-table .rowOne td {
  background: #0D1456;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #fff;
  color: #333;
}

/deep/ .el-table::before {
  height: 0;
}

/deep/ .el-dialog__title {
  color: #fff;
}

.searchForm /deep/ .el-form-item__label {
  color: #fff;
}

/deep/ .el-table th.is-leaf {
  color: #fff;
}

</style>
